<template>
  <section class="container">
    <div class="row">
      <div class="col">
        <div id="login-page">
          <div @click="goToHome()" class="icon-shop">
            <b-icon icon="arrow-up-left-square-fill" />
            <span class="icon-text">Back to shop</span>
          </div>
          <h2 class="form-title">Login</h2>
          <form @submit.prevent="login()" id="form-login">
            <div class="form-group">
              <input class="form-control" type="text" v-model="email" id="email-login" placeholder="Email">
            </div>
            <div class="form-group">
              <input class="form-control" type="password" v-model="password" id="password-login" placeholder="Password">
              <p class="login-warning text-danger"></p>
            </div>
            <div class="form-group">
              <button class="btn btn-primary" id="btn-login" type="submit">Login</button>
              <p>Dont have account? <a class="a-login" @click.prevent="goToRegister()" href="#">Register</a></p>
            </div>
          </form>
        </div>
      </div>
      <div class="col">
        <div>
          <img class="login-register-img" src="../assets/login-register.jpg"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    goToRegister () {
      this.$router.push('/register')
    },
    goToHome () {
      this.$router.push('/')
    },
    login () {
      const user = {
        email: this.email,
        password: this.password
      }
      this.$store.dispatch('login', user)
      this.email = ''
      this.password = ''
    }
  }
}
</script>

<style scoped>
  .form-group {
    margin: 7px 0;
  }
  .form-title {
    margin-bottom: 20px;
  }
  .a-login {
    font-weight: bold;
  }
  .btn {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .container {
    background: #e2e2e2;
    margin-top: 80px;
    padding: 0;
  }
  .icon-shop {
    position: absolute;
    top: 0px;
    left: 20px;
    font-size: 30px;
  }
  .icon-shop:hover {
    color: navy;
    cursor: pointer;
  }
  .icon-shop:active {
    color: #263e4f;
  }
  .icon-text {
    padding: 7px;
    font-size: 15px;
  }
  .login-register-img {
    width: 100%
  }
  a {
    text-shadow: 0 0 10px 10px black;
  }
  #login-page {
    margin: auto;
    margin-top: 85px;
    width: 60%
  }
</style>
